// import { gsap } from 'gsap';
// import { IS_SP } from '../const/config';

// SPのヘッダーメニューボタン
export class HeaderMemu {
  constructor() {
    this.DOM = {};
    this.DOM.menuButton = document.querySelector('[data-menu-button]');
    this.DOM.menuContent = document.querySelector('[data-menu-content]');

    if (!this.DOM.menuButton) return;

    this.init();
  }

  init() {

    // ヘッダーメニューボタンのクリックイベント
    this.DOM.menuButton.addEventListener('click', () => {
      if( !this.isMenuOpend() ) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    });

    this.DOM.menuContent.addEventListener('click', (event) => {
      if (event.target === event.currentTarget) {
        // 親要素のときのみ実行
        if( !this.isMenuOpend() ) {
          this.openMenu();
        } else {
          this.closeMenu();
        }
      }

    });
    
    
  }

  isMenuOpend() {
    if(this.DOM.menuButton.classList.contains('is-opened')) {
      return true;
    } else {
      return false;
    }
  }

  openMenu() {
    this.DOM.menuButton.classList.add('is-opened');
    this.DOM.menuContent.classList.add('is-opened');
    

  }

  closeMenu(){
    this.DOM.menuButton.classList.remove('is-opened');
    this.DOM.menuContent.classList.remove('is-opened');

  }
}
